export default __webpack_public_path__ + "static/media/mercearia.219cc90e.jpg";